import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: '底部导航',
      component: function (resolve) {
        require(['@/components/pages-footer.vue'], resolve);
      },
      redirect: '/homeIndex',
      children: [
        {
          path: '/homeIndex',
          name: '首页',
          component: function (resolve) {
            require(['@/views/home/home-index.vue'], resolve);
          },
          meta: {
            keepAlive: true //不需要被缓存的组件
          }
        },
        {
          path: '/courseIndex',
          name: '精品课',
          component: function (resolve) {
            require(['@/views/course/course-index.vue'], resolve);
          },
          meta: {
            keepAlive: true, //不需要被缓存的组件
          }
        },
        {
          path: '/learnIndex',
          name: '学习',
          component: function (resolve) {
            require(['@/views/learn/learn-index.vue'], resolve);
          },
          meta: {
            keepAlive: false //不需要被缓存的组件
          }
        },
        {
          path: '/personalIndex',
          name: '我的',
          component: function (resolve) {
            require(['@/views/personal/personal-index.vue'], resolve);
          },
          meta: {
            keepAlive: false //不需要被缓存的组件
          }
        }
      ]
    },
    
    {
      path: '/xjsitelist',
      name: 'xjsitelist',
      component: function (resolve) {
        require(['@/views/home/xjsitelist.vue'], resolve);
      },
      meta: {
        keepAlive: true, //不需要被缓存的组件
      }
    },
    // 名师风采页面
    {
      path: '/teacherIndex',
      name: '名师风采首页',
      component: function (resolve) {
        require(['@/views/teacher/teacher-index.vue'], resolve);
      }, meta: {
        keepAlive: true //不需要被缓存的组件
      }
    },
    {
      path: '/teacherDetail',
      name: '主讲人详情',
      component: function (resolve) {
        require(['@/views/teacher/teacher-detail.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 练习题列表页
    {
      path: '/practiceList',
      name: '练习题列表',
      component: function (resolve) {
        require(['@/views/practice/practice-list.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 培训计划路由
    {
      path: '/trainplan',
      name: '培训计划',
      component: function (resolve) {
        require(['@/views/learn/trainPlan/plan-page.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      },
      redirect: '/trainplan-plan-list',
      children: [

      ]
    },
    {
      path: '/trainplan-plan-list',
      name: '计划列表',
      component: function (resolve) {
        require(['@/views/learn/trainPlan/plan-list.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    }, {
      path: '/trainplan-plan-detail',
      name: '计划详情',
      component: function (resolve) {
        require(['@/views/learn/trainPlan/plan-detail.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    }, {
      path: '/trainplan-plan-pay-page',
      name: '计划支付',
      component: function (resolve) {
        require(["@/views/learn/trainPlan/plan-pay-page.vue"], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    }, {
      path: '/trainplan-plan-add-course',
      name: '选择课程',
      component: function (resolve) {
        require(["@/views/learn/trainPlan/plan-add-course.vue"], resolve);
      }, meta: {
        keepAlive: true //不需要被缓存的组件
      }
    },
    {
      path: '/quickSelect',
      name: '快速选课',
      component: function (resolve) {
        require(["@/views/learn/trainPlan/quickSelect.vue"], resolve);
      }, meta: {
        keepAlive: true //不需要被缓存的组件
      }
    },
    // 支付中心
    {
      path: '/fkxx',
      name: '反馈信息',
      component: function (resolve) {
        require(['@/views/fkxx/fkxx.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 支付中心
    {
      path: '/paymentList',
      name: '支付中心',
      component: function (resolve) {
        require(['@/views/payment/payment-list.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 获取openid
    {
      path: '/getOpenId',
      name: '获取openid',
      component: function (resolve) {
        require(['@/views/payment/getopenid.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 支付状态
    {
      path: '/card-active',
      name: '卡号支付',
      component: function (resolve) {
        require(['@/views/payment/card-active.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 支付状态
    {
      path: '/pay-statue',
      name: '支付中心',
      component: function (resolve) {
        require(['@/views/payment/pay-statue.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 支付状态
    {
      path: '/payBack',
      name: '支付回调',
      component: function (resolve) {
        require(['@/views/payment/pay-back.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/unitpay',
      name: '单位支付',
      component: function (resolve) {
        require(['@/views/payment/unit-pay.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/unionPay',
      name: '银联支付',
      component: function (resolve) {
        require(['@/views/payment/unionpay.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/payMethods',
      name: '银联支付',
      component: function (resolve) {
        require(['@/views/payment/paymethods.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },

    {
      path: '/toPaylist',
      name: '编辑订单',
      component: function (resolve) {
        require(['@/views/payment/payment-edit.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/invoice',
      name: '补开发票',
      component: function (resolve) {
        require(['@/views/payment/invoice.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 我的培训计划路由
    {
      path: '/myplan',
      name: '培训计划',
      component: function (resolve) {
        require(['@/views/learn/myPlan/plan-page.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      },
      redirect: '/myplan-plan-list',
      children: [

      ]
    },
    {
      path: '/myplan-plan-list',
      name: '培训计划列表',
      component: function (resolve) {
        require(['@/views/learn/myPlan/plan-list.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    }, {
      path: '/myplan-plan-detail',
      name: '培训计划详情',
      component: function (resolve) {
        require(['@/views/learn/myPlan/plan-detail.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },  {
      path: '/uploadnote',
      name: '培训计划详情',
      component: function (resolve) {
        require(['@/views/learn/myPlan/uploadnote.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    }, {
      path: '/myplan-add-detail',
      name: '自修包添加课程详情',
      component: function (resolve) {
        require(['@/views/learn/myPlan/add-detail.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    }, {
      path: '/myplan-add-course',
      name: '添加课程',
      component: function (resolve) {
        require(['@/views/learn/myPlan/add-course.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    }, {
      path: '/addBuyCourse',
      name: '购买课程',
      component: function (resolve) {
        require(['@/views/learn/myPlan/addBuyCourse.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 我的课程路由
    {
      path: '/learn-mycourse',
      name: '我的课程',
      component: function (resolve) {
        require(['@/views/learn/learn-mycourse.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 我的课程申请证书路由
    {
      path: '/concert-course',
      name: '申请证书',
      component: function (resolve) {
        require(['@/views/learn/concert-course.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 我的课程选择证书路由
    {
      path: '/choose',
      name: '选择证书',
      component: function (resolve) {
        require(['@/views/learn/choose.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 我的课程确认证书路由
    {
      path: '/Validation',
      name: '确认证书',
      component: function (resolve) {
        require(['@/views/learn/Validation.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 查看课程
    {
      path: '/down_classDetail',
      name: '查看课程',
      component: function (resolve) {
        require(['@/views/learn/down_classDetail.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 下载页面路由
    {
      path: '/down-load',
      name: '下载证书',
      component: function (resolve) {
        require(['@/views/learn/down-load.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 作废课页面路由yf
    {
      path: '/voidcourse',
      name: '作废课',
      component: function (resolve) {
        require(['@/views/learn/voidcourse.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 下载列表页面路由
    {
      path: '/down-cert',
      name: '下载证书列表',
      component: function (resolve) {
        require(['@/views/learn/down-cert.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    //考试卡
    {
      path: '/theTestCard-index',
      name: '考试卡首页',
      component: function (resolve) {
        require(['@/views/theTestCard/theTestCard-index.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/theTestCard-test',
      name: '答题卡',
      component: function (resolve) {
        require(['@/views/theTestCard/theTestCard-test.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    //考试卡激活
    {
      path: '/theTestCard-active',
      name: '考试卡',
      component: function (resolve) {
        require(['@/views/theTestCard/activeTestCard.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 登录注册相关页面
    {
      path: '/login',
      name: '登录',
      component: function (resolve) {
        require(['@/views/personal/login.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 登录注册相关页面
    {
      path: '/unionlogin',
      name: '登录',
      component: function (resolve) {
        require(['@/views/personal/unionlogin.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/forgetPw',
      name: '忘记密码',
      component: function (resolve) {
        require(['@/views/personal/forget-pw.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/register',
      name: '注册',
      component: function (resolve) {
        require(['@/views/personal/register.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/promotereg',
      name: '注册',
      component: function (resolve) {
        require(['@/views/personal/promotereg.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/regDeal',
      name: '注册协议',
      component: function (resolve) {
        require(['@/views/personal/reg-deal.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    // 个人中心相关页面
    {
      path: '/lookEnit',
      name: '个人资料',
      component: function (resolve) {
        require(['@/views/personal/components/look-enit.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }

    },

    {
      path: '/shopCar',
      name: '购物车',
      component: function (resolve) {
        require(['@/views/personal/shopCar.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }

    },
    {
      path: '/enitPassWord',
      name: '修改密码',
      component: function (resolve) {
        require(['@/views/personal/components/enit-pass-word.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    }, {
      path: '/address',
      name: '地址管理',
      component: function (resolve) {
        require(['@/views/personal/components/address.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    }, {
      path: '/newBuilt',
      name: '新增地址',
      component: function (resolve) {
        require(['@/views/personal/components/new-built.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/unit',
      name: '选择单位',
      component: function (resolve) {
        require(['@/views/personal/components/unit.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    }, {
      path: '/enitUnit',
      name: '编辑单位',
      component: function (resolve) {
        require(['@/views/personal/components/enit-unit.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/phone',
      name: '注册/修改手机',
      component: function (resolve) {
        require(['@/views/personal/phone.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/seting',
      name: '设置',
      component: function (resolve) {
        require(['@/views/personal/components/seting.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/my-coupon',
      name: '优惠券',
      component: function (resolve) {
        require(['@/views/personal/personal-coupon.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/my-order',
      name: '我的订单',
      component: function (resolve) {
        require(['@/views/personal/personal-order.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/personalInvoice',
      name: '我的发票',
      component: function (resolve) {
        require(['@/views/personal/personalInvoice.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/xxda',
      name: '我的订单',
      component: function (resolve) {
        require(['@/views/personal/personal-xxda.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/my-message',
      name: '我的消息',
      component: function (resolve) {
        require(['@/views/personal/personal-message.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/messageDetail',
      name: '我的消息详情',
      component: function (resolve) {
        require(['@/views/personal/message-detail.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/aboutUs',
      name: '关于我们',
      component: function (resolve) {
        require(['@/views/personal/components/aboutUs.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/contactUs',
      name: '联系我们',
      component: function (resolve) {
        require(['@/views/personal/components/contactUs.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/agreement',
      name: '平台服务协议',
      component: function (resolve) {
        require(['@/views/personal/components/agreement.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/privacyStatement',
      name: '隐私政策',
      component: function (resolve) {
        require(['@/views/personal/components/privacyStatement.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/courseDetails',
      name: '课程详情',
      component: function (resolve) {
        require(['@/views/course/course-details.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/liveList',
      name: '直播列表',
      component: function (resolve) {
        require(['@/views/live/liveList.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/liveDetail',
      name: '直播详情',
      component: function (resolve) {
        require(['@/views/live/liveDetail.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/live',
      name: '直播间',
      component: function (resolve) {
        require(['@/views/live/live.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/replay',
      name: '直播回放',
      component: function (resolve) {
        require(['@/views/live/replay.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/liveRegister',
      name: '直播注册',
      component: function (resolve) {
        require(['@/views/personal/liveRegister.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/rate',
      name: '更多评价',
      component: function (resolve) {
        require(['@/views/course/rate.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/planrate',
      name: '更多评价',
      component: function (resolve) {
        require(['@/views/course/planrate.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/play-course',
      name: '课程播放',
      component: function (resolve) {
        require(['@/views/learn/play-course.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    }, {
      path: '/safeCenter',
      name: '安全中心',
      component: function (resolve) {
        require(['@/views/home/safe/safe-center.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },{
      path: '/helpCenter',
      name: '帮助中心',
      component: function (resolve) {
        require(['@/views/home/help/help-center.vue'], resolve);
      }, meta: {
        keepAlive: true //不需要被缓存的组件
      }
    }, {
      path: '/helpDetail',
      name: '帮助中心详情',
      component: function (resolve) {
        require(['@/views/home/help/help-detail.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    }, {
      path: '/sign-up',
      name: '现场报名',
      component: function (resolve) {
        require(['@/views/learn/sign-up.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    }, {
      path: '/exam-results',
      name: '考试成果',
      component: function (resolve) {
        require(['@/views/learn/exam-results.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    }, {
      path: '/exam-results-details',
      name: '考试成果详情',
      component: function (resolve) {
        require(['@/views/learn/exam-results-details.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },{
      path: '/bind',
      name: '绑定账号',
      component: function (resolve) {
        require(['@/views/personal/bind.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },{
      path: '/enderYear',
      name: '年终活动',
      component: function (resolve) {
        require(['@/views/enderYear/enderYear.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },{
      path: '/downLoad',
      name: '查看报告',
      component: function (resolve) {
        require(['@/views/enderYear/downLoad.vue'], resolve);
      }, meta: {
        keepAlive: false //不需要被缓存的组件
      }
    },
    {
      path: '/courseH5',
      name: '精品课',
      component: function (resolve) {
        require(['@/views/course/courseH5.vue'], resolve);
      },
      meta: {
        keepAlive: false, //不需要被缓存的组件
      }
    },
    {
      path: '/courseH5details',
      name: '课程详情',
      component: function (resolve) {
        require(['@/views/course/courseH5details.vue'], resolve);
      },
      meta: {
        keepAlive: false, //不需要被缓存的组件
      }
    },
  ],
  //自动滚动到顶部的方法
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 }
    }
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js